import { useContext } from "react";
import FormField from "../Input/FormField";
import Button from "../Input/Button";
import { useFormik } from "formik";
import Context from "../../../context";
import axios from "axios";
import { API_URL } from "../../data/constants";

export default function ForgotPasswordPage() {
  const { contextState, setContextState } = useContext(Context);

  function validate(values) {
    const errors = {};
    if (!values.email) {
      errors.email = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    return errors;
  }

  const forgotForm = useFormik({
    initialValues: {
      email: "",
    },
    validate,
    onSubmit: (values) => {
      axios
        .post(API_URL + "/Users/ForgotPassword", {
          userName: values.email,
        })
          .then((res) => {
            let data = {
              type: "message",
              title: res.data.title,
              content: res.data.message,
            };
            setContextState({ ...contextState, modal: data });
          })
        .catch((err) => console.error(err));
    },
  });

  return (
    <>
      <h3 className="login-header">Password Reset</h3>
      <form className="login-form" onSubmit={forgotForm.handleSubmit}>
        <FormField
          field="email"
          type="email"
          name="Account Email"
          form={forgotForm}
        />
        <Button
          className="btn btn-fluid btn--green btn--bordered"
          type="submit"
          disabled={!(forgotForm.dirty && forgotForm.isValid)}
          text="Send Password Reset Link"
        />
      </form>
      <span
        className="login-link"
        onClick={() => {
          setContextState({ ...contextState, loginActivePage: "login" });
        }}>
        Back to Login
      </span>
    </>
  );
}
